
/* CUSTARD SHOP — CART UPSELLS */

(() => {
  if (window.CustardUpsellsLoaded) return;
  window.CustardUpsellsLoaded = true;

  const HANDLES = [
    'pre-order-pinstripe-wool-6-panel-short-brim-initial-adjustable-cap',
    'splodge-socks-white-5'
  ];

  const root = window.Shopify?.routes?.root || '/';
  const endpoint = (path) => root + path;
  const cache = new Map();

  const money = (cents) => {
    const currency =
      window.Shopify?.currency?.active || 'GBP';

    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-GB',
      { style: 'currency', currency }
    ).format(cents / 100);
  };

  async function getProduct(handle) {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch(
          endpoint('products/' +
            encodeURIComponent(handle) + '.js')
        ).then((response) => {
          if (!response.ok) {
            throw new Error('Product unavailable');
          }
          return response.json();
        })
      );
    }

    return cache.get(handle);
  }

  function makeCard(product) {
    const card = document.createElement('div');
    card.className = 'custard-upsell-product';

    const image = document.createElement('img');
    image.src = product.featured_image || '';
    image.alt = product.title;
    image.loading = 'lazy';

    const details = document.createElement('div');
    details.className = 'custard-upsell-product__details';

    const title = document.createElement('a');
    title.href = product.url ||
      endpoint('products/' + product.handle);
    title.textContent = product.title;
    title.className = 'custard-upsell-title';

    const price = document.createElement('div');
    price.className = 'custard-upsell-price';

    const select = document.createElement('select');
    select.className = 'custard-upsell-select';
    select.setAttribute(
      'aria-label',
      'Choose option for ' + product.title
    );

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'custard-upsell-product__button';
    button.textContent = '+ ADD TO CART';

    const message = document.createElement('div');
    message.className = 'custard-upsell-message';
    message.setAttribute('role', 'status');

    product.variants.forEach((variant) => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title;
      option.disabled = !variant.available;
      select.appendChild(option);
    });

    const firstAvailable = product.variants.find(
      (variant) => variant.available
    );

    if (firstAvailable) {
      select.value = String(firstAvailable.id);
    }

    function updateVariant() {
      const variant = product.variants.find(
        (item) => String(item.id) === select.value
      );

      if (!variant) return;

      price.textContent = money(variant.price);
      button.disabled = !variant.available;
      button.textContent = variant.available
        ? '+ ADD TO CART'
        : 'SOLD OUT';
    }

    select.addEventListener('change', updateVariant);
    updateVariant();

    // Hide unnecessary variant dropdowns
    if (
      product.variants.length === 1 &&
      product.variants[0].title === 'Default Title'
    ) {
      select.hidden = true;
    }

    button.addEventListener('click', async () => {
      if (button.disabled) return;

      button.disabled = true;
      button.textContent = 'ADDING...';
      message.textContent = '';

      try {
        const drawer = document.querySelector('cart-drawer');

        const sections = drawer?.getSectionsToRender?.()
          .map((section) => section.id) || [];

        const body = {
          items: [{
            id: Number(select.value),
            quantity: 1
          }]
        };

        if (sections.length) {
          body.sections = sections;
          body.sections_url = window.location.pathname;
        }

        const response = await fetch(
          endpoint('cart/add.js'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify(body)
          }
        );

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Unable to add this product.'
          );
        }

        if (drawer && sections.length && result.sections) {
          drawer.renderContents(result);
        } else {
          document.dispatchEvent(
            new CustomEvent('custard:cart-updated')
          );

          if (drawer?.open) drawer.open();
        }

      } catch (error) {
        message.textContent = error.message;
        button.disabled = false;
        updateVariant();
      }
    });

    details.append(
      title,
      price,
      select,
      button,
      message
    );

    card.append(image, details);
    return card;
  }

  let rendering = false;

  async function renderUpsells() {
    const container = document.getElementById(
      'custard-cart-upsell-products'
    );

    if (!container || rendering) return;

    // Avoid rebuilding cards on every DOM change
    if (container.dataset.loaded === 'true') return;

    rendering = true;

    try {
      const results = await Promise.allSettled(
        HANDLES.map(getProduct)
      );

      if (!container.isConnected) return;

      const products = results
        .filter((result) => result.status === 'fulfilled')
        .map((result) => result.value);

      container.replaceChildren(
        ...products.map(makeCard)
      );

      container.dataset.loaded = 'true';

      const section = container.closest(
        '.custard-cart-upsells'
      );

      if (section) {
        section.hidden = products.length === 0;
      }

    } finally {
      rendering = false;
    }
  }

  // Shopify replaces cart drawer HTML after cart updates.
  // Watch for a new upsell container and populate it.
  const observer = new MutationObserver(() => {
    const container = document.getElementById(
      'custard-cart-upsell-products'
    );

    if (container && container.dataset.loaded !== 'true') {
      renderUpsells();
    }
  });

  function init() {
    renderUpsells();

    const drawer = document.querySelector('cart-drawer');

    if (drawer) {
      observer.observe(drawer, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();
